<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="allianceSelected"
    :clearable="!unclearable"
    :items="allianceItems"
    :loading="allianceLoading"
    :label="
          noLabel
            ? ''
            : label
            ? label
            : $t('Complaint.alliance', [$consts.allianceName()])
        "
    :search-input.sync="allianceSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import AllianceBusinesses from "@/api/alliance_businesses";


export default {
  name: "SearcherAlliance",

  props: {
    value: Object,
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    label: String,

  },

  computed: {
    allianceItems() {
      return this.alliance.map((c) => {
        const Description =
          c.alliance_business_code +
          " / " +
          c.alliance_business_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == c.id)
          : false;
        return Object.assign({}, c, { Description, disabled });
      });
    },
  },

  data: () => ({
    alliance: [],
    allianceLoading: false,
    allianceSearch: "",
    allianceSelected: null,
  }),
  mounted(){
      this.allianceLoading = true;
      AllianceBusinesses.fetchAllForSelect()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
                this.alliance = response.data.alliance_businesses;
            }
            this.allianceLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.allianceLoading = false;
          }.bind(this)
        );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.allianceSelected = this.value;
      },
    },
    allianceSelected: {
      handler() {
        this.$emit("input", this.allianceSelected);
      },
    },
  },

};
</script>